import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c2353e06"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "numberError"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createTextVNode("It's seems we cannot find your ressources... "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("(404 : Not Found)")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NumberAnimation = _resolveComponent("NumberAnimation");
  const _component_w_icon = _resolveComponent("w-icon");
  const _component_CenterTop = _resolveComponent("CenterTop");
  return _openBlock(), _createBlock(_component_CenterTop, {
    logo: require('@/assets/theme/world_connect.png')
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_NumberAnimation, {
      to: 404,
      duration: 3,
      delay: 0
    })]), _hoisted_3, _createElementVNode("div", null, [_createVNode(_component_w_icon, {
      icon: "emoticon-sad",
      "font-size": "48px",
      class: "not-found-icon"
    })])])]),
    _: 1
  }, 8, ["logo"]);
}